module.exports = __webpack_public_path__ + "static/media/fundo-countdownblack.8cba6e0a.png";